import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

@Entity('_conversation_daily_usage')
@Index(['date'], { unique: true })
export class ConversationDailyUsageEntity extends BaseEntity {
	// Time Period
	@Column({ type: 'date' })
	public date!: Date;

	@Column({ type: 'int', unsigned: true })
	public year!: number;

	@Column({ type: 'int', unsigned: true })
	public month!: number;

	@Column({ type: 'int', unsigned: true })
	public dayOfMonth!: number;

	@Column({ type: 'int', unsigned: true })
	public dayOfWeek!: number; // 0=Sunday, 1=Monday, ..., 6=Saturday

	@Column({ type: 'enum', enum: ['weekday', 'saturday', 'sunday'] })
	public dayType!: 'weekday' | 'saturday' | 'sunday';

	// Usage Metrics
	@Column({ type: 'int', unsigned: true, default: 0 })
	public voiceSeconds!: number;

	@Column({ type: 'int', unsigned: true, default: 0 })
	public llmTokens!: number;

	@Column({ type: 'int', unsigned: true, default: 0 })
	public totalVoice!: number;

	@Column({ type: 'int', unsigned: true, default: 0 })
	public totalChats!: number;
}
